/**
 * mc-promo-stripe.js — faixa promocional Grafite (task 0029 · F1 · D7)
 *
 * Rotação mobile (≤989px) das mensagens da faixa: alterna .is-on por opacity
 * (nunca display/visibility/aria — árvore de acessibilidade estável, AJ-2/0009).
 * Estática em prefers-reduced-motion e ≥990px; pausa em hover/focus e via tap
 * persistente em telas de toque (WCAG 2.2.2); pausa com a aba oculta.
 * Sem live region. mc-header.js: intocado.
 *
 * R3 (review F1): em dispositivos (hover: none) o tap dispara mouseenter
 * SINTÉTICO antes do click — o par pause/toggle invertia o estado. Nesses
 * dispositivos os eventos de mouse são ignorados e o toggle é SÓ pelo click
 * (pausa persistente até novo tap).
 */

(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-mc-stripe]').forEach(function (stripe) {
      var msgs = stripe.querySelectorAll('[data-mc-stripe-msg]');
      if (msgs.length < 2) return;
      var mobile = window.matchMedia('(max-width: 989px)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var touch = window.matchMedia('(hover: none)');
      var delay = parseInt(stripe.getAttribute('data-rotation'), 10) || 3800;
      var index = 0;
      var paused = false;

      setInterval(function () {
        if (paused || document.hidden || reduce.matches || !mobile.matches) return;
        msgs[index].classList.remove('is-on');
        index = (index + 1) % msgs.length;
        msgs[index].classList.add('is-on');
      }, delay);

      stripe.addEventListener('mouseenter', function () {
        if (touch.matches) return; /* mouseenter sintético do tap não pausa (R3) */
        paused = true;
      });
      stripe.addEventListener('mouseleave', function () {
        if (touch.matches) return; /* idem — despausa só por novo tap */
        paused = false;
      });
      stripe.addEventListener('focusin', function () { paused = true; });
      stripe.addEventListener('focusout', function () { paused = false; });
      stripe.addEventListener('click', function (event) {
        if (event.target.closest('a')) return; /* mensagem com link navega normalmente */
        if (!touch.matches) return; /* com mouse, hover já cobre a pausa */
        paused = !paused; /* tap alterna pausa/retoma — persistente */
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
